import { Message } from 'element-ui'
import axios, { urlList } from '@/xhr'

import { isObject, cycle2Number, getTime } from './utils'

function deepMap(sourceObj, mapObj) {
  var obj = {}
  for (let k in mapObj) {
    if (mapObj[k]) {
      obj[k] = sourceObj[mapObj[k]]
    }
  }

  let children = sourceObj.children
  if (children && children.length) {
    obj.children = []
    for (var i = 0; i < children.length; i++) {
      var item = children[i]
      obj.children.push(deepMap(item, mapObj))
    }
  }
  return obj
}

function reduceUnits(data) {
  const map = {
    label: 'text',
    value: 'id',
  }

  const obj = deepMap(data, map)
  return obj.children
}

export async function fetchUnitOptions() {
  try {
    const res = await axios.get(urlList.account + 'unit/tree/f/area')
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    }

    return reduceUnits(res.data.data)
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

export async function fetchProvinceOptions() {
  try {
    const res = await axios.post(urlList.search + 'baseDataInfo', {
      baseDataType: 'PROVINCE__INFO',
    })
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    }

    return res.data.data.map(item => ({
      label: item.province,
      value: item.provinceId,
    }))
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

export async function fetchCityOptions(provinceId) {
  try {
    const res = await axios.post(urlList.search + 'baseDataInfo', {
      baseDataType: 'CITY_INFO',
      provinceId,
    })
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    }

    return res.data.data.map(item => ({
      label: item.city,
      value: item.cityId,
    }))
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

export async function fetchDistrictOptions(cityId) {
  try {
    const res = await axios.post(urlList.search + 'baseDataInfo', {
      baseDataType: 'AREA_INFO',
      cityId,
    })
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    }

    return res.data.data.map(item => ({
      label: item.area,
      value: item.areaId,
    }))
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

// 投资代表
export async function fetchHKOptions() {
  const cities = JSON.parse(this.$store.state.currentUser.houseData)
  let ret = []
  for (const innerCities of cities) {
    let obj = {}
    obj.label = innerCities.label
    obj.value = innerCities.label
    obj.children = []
    for (const user of innerCities.cities) {
      const newUser = {
        label: user.label,
        value: user.id || user.label,
        phone: user.phone || null,
      }
      obj.children.push(newUser)
    }
    ret.push(obj)
  }
  return ret
}

// 搜索社区
export async function fetchBlocks(kw) {
  try {
    // no search prefix.
    const res = await axios.post('block/list/block', {
      blockName: kw,
      pageNo: 1,
      pageSize: 20,
    })
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    } else if (!Array.isArray(res.data.data.list)) {
      return Promise.reject('no list in data')
    }

    return res.data.data.list.map(item => ({
      label: item.blockName,
      value: item.pid,
    }))
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

export async function fetchPhaseFeeList(reqChargInputBean, MONEY_SIZE = 1000) {
  try {
    const res = await axios.post(urlList.rent + 'algorithm/list/phaseFee', {
      enumCompanyName: 'HZ',
      reqChargInputBean: {
        addCycle: 0, // --增长周期
        addPer: 0, // --增长百分比
        addType: 'NOTRISE', // --是否增长
        addUnit: 'MONTH', // --增长单位
        advanceDays: 0, // --提前付款天数
        businessType: 'DEL', // --托管还是租约 需给DEL
        chargType: 'REN', // --费用类型
        cycle: 0, // --费用周期
        endChargTime: '2019-06-20T09:11:34.883Z', // --结束时间
        rentalFreeEnd: '2019-06-20T09:11:34.883Z', // --免租期结束时间
        rentalFreeStart: '2019-06-20T09:11:34.883Z', // --免租期开始时间
        startChargTime: '2019-06-20T09:11:34.883Z', // --开始时间

        unit: 'MONTH', // --付款单位
        financeType: 'PAY', // --收入/支出
        ...reqChargInputBean,
        initialAmount: reqChargInputBean.initialAmount * MONEY_SIZE,
      },
    })
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    }

    const req = reqChargInputBean
    const { phaseFees, totalAmount } = res.data.data
    const _phaseFees = phaseFees.map(o => ({
      advanceDays: req.advanceDays,
      initialAmount: o.amount / MONEY_SIZE,
      startChargTime: o.startTime,
      endChargTime: o.endTime,
      _payDate: o.shouldPayTime,
    }))
    return [_phaseFees, totalAmount]
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

export async function fetchHouseSpace(houseSpaceId) {
  try {
    const res = await axios.get(
      urlList.house + 'houseSpaceManager/get/' + houseSpaceId
    )
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    }

    if (isObject(res.data.data)) {
      const data = res.data.data
      return {
        zone: data.zone,
        zoneId: data.zoneId,
        blockName: data.blockName,
        blockId: data.blockId,
        buildingNo: data.buildingNo,
        unitNo: data.unitNo,
        roomNo: data.roomNo,
        companyId: data.companyId,
      }
    } else {
      return Promise.reject(new Error('数据为空'))
    }
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}
// 详细地址回显
export async function fetchHouseaddress(contractId) {
  try {
    const res = await axios.get(
      '/contract/getHouseSpaceManager/' + contractId
    )
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    }

    if (isObject(res.data.data)) {
      const data = res.data.data
      return {
        houseOwnershipCertificateAddress: data.houseOwnershipCertificateAddress,
      }
    } else {
      return Promise.reject(new Error('数据为空'))
    }
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

// 获取所属公司选项
export async function fetchCompanyOptions() {
  try {
    const res = await axios.get(urlList.house + 'company/list/all')
    if (res.data.code !== 200) {
      Message.error(res.data.message)
      return Promise.reject(res.data)
    } else if (!Array.isArray(res.data.data)) {
      return Promise.reject('no list in data')
    }
    return res.data.data.map(item => ({
      label: item.companyName,
      value: item.companyId,
    }))
  } catch (e) {
    Message.error(e.message)
    return Promise.reject(e)
  }
}

/**
 * 从表单中获取获取费用接口的请求参数
 * @param {object} form
 * @param {'REN' | 'PERFEE'} chargType
 */
export function getRequest(form, chargType) {
  if (!form) return new Error('表单为空值')

  const { startTime, endTime, advanceDays, cycle, firstRental, perfee } = form
  let initialAmount
  if (!startTime) {
    return new Error('开始时间 不能为空')
  } else if (!endTime) {
    return new Error('结束时间 不能为空')
  } else if (!advanceDays && advanceDays !== 0) {
    return new Error('提前付款天数 不能为空')
  } else if (!cycle) {
    return new Error('付款周期 不能为空')
  }

  let { rentalIsAdd } = form
  if (chargType === 'REN') {
    if (!firstRental && firstRental !== 0) {
      return new Error('首年月租金 不能为空')
    }

    initialAmount = firstRental
  } else if (chargType === 'PERFEE') {
    if (!perfee && perfee !== 0) {
      return new Error('物管费金额 不能为空')
    }

    initialAmount = perfee
    rentalIsAdd = false // 物管费不递增
  }

  const startChargTime = getTime(startTime)
  const endChargTime = getTime(endTime)

  const { centralizeRentalFreeStart, centralizeRentalFreeEnd } = form
  const rentalFreeStart = getTime(centralizeRentalFreeStart)
  const rentalFreeEnd = getTime(centralizeRentalFreeEnd)

  let addType = rentalIsAdd ? 'RISEBYPER' : 'NOTRISE'
  let addCycle, addPer
  if (rentalIsAdd) {
    const { rentalAddProbability, rentalAddProbabilityRatio } = form
    if (!rentalAddProbability) {
      return new Error('租金递增率 不能为空')
    } else if (!rentalAddProbabilityRatio && rentalAddProbabilityRatio !== 0) {
      return new Error('租金递增率 不能为空')
    }
    addCycle = rentalAddProbability
    addPer = rentalAddProbabilityRatio
  }

  const req = {
    addCycle, // --增长周期
    addPer, // --增长百分比
    addType, // --是否增长
    advanceDays, // --提前付款天数
    chargType, // --费用类型
    cycle: cycle2Number(cycle), // --费用周期
    initialAmount, // --初始金额
    rentalFreeStart, // --免租期开始时间
    rentalFreeEnd, // --免租期结束时间
    startChargTime, // --开始时间
    endChargTime, // --结束时间
  }

  return req
}



// WEBPACK FOOTER //
// ./src/page/none/workflow/trusteeship/forms/fetch.js